// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!../../@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!../../postcss-loader/dist/cjs.js??clonedRuleSet-54.use[3]!./vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&shadow&external");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add CSS to Shadow Root
var add = require("!../../vue-style-loader/lib/addStylesShadow.js").default
module.exports.__inject__ = function (shadowRoot) {
  add("891c8e2e", content, shadowRoot)
};